import React, { useState } from 'react';
import { loginUser } from '../services/authService'; // Import loginUser

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
      const data = await loginUser(username, password);
      alert(data.message);
      // TODO: Handle successful login (e.g., store token, redirect to home)
    } catch (error: any) {
      console.error('Error during login:', error);
      alert(error); // Display error message from service
    }
  };

  return (
    <div>
      <h1>Login</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="username">Username:</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Login</button>
      </form>
      <p>Don't have an account? <a href="/register">Register here</a></p>
      <p><a href="/">Back to Home</a></p>
    </div>
  );
};

export default LoginPage;
